import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TimerContext = createContext(null);

export function TimerProvider({ children }) {
  const { user } = useAuth();
  const [activeLog, setActiveLog] = useState(null);
  const [, setTick] = useState(0);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!user) {
      setActiveLog(null);
      return;
    }
    api
      .get("/timelogs/active")
      .then((r) => setActiveLog(r.data || null))
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    if (!activeLog) return;
    const i = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(i);
  }, [activeLog]);

  const elapsed = activeLog
    ? Math.floor((Date.now() - new Date(activeLog.start_time).getTime()) / 1000)
    : 0;

  const start = useCallback(async (payload) => {
    const r = await api.post("/timelogs/start", payload);
    setActiveLog(r.data);
    setVersion((v) => v + 1);
    return r.data;
  }, []);

  const stop = useCallback(async () => {
    if (!activeLog) return null;
    const r = await api.post(`/timelogs/${activeLog.log_id}/stop`);
    setActiveLog(null);
    setVersion((v) => v + 1);
    return r.data;
  }, [activeLog]);

  const value = useMemo(
    () => ({ activeLog, elapsed, start, stop, version, setVersion }),
    [activeLog, elapsed, start, stop, version]
  );

  return (
    <TimerContext.Provider value={value}>
      {children}
    </TimerContext.Provider>
  );
}

export const useTimer = () => useContext(TimerContext);
